/**
 * @typedef {Object} PromotionCard
 * @property {string} key
 * @property {string} title
 * @property {string} content
 * @property {string} image
 * @property {string} category - Payload slug (poker | gaming-machines | restaurants)
 * @property {string} url - Internal path from Payload (localized); routing lives in PGCA routes.json
 * @property {string} [publish_at]
 * @property {string} [unpublish_at]
 * @property {string} [buttonLabel]
 * @property {string} [imageAlt]
 */

/**
 * Maps a Payload `promotions` document to the legacy ERS card shape
 * consumed by Promotions.jsx and shouldPublish().
 *
 * @param {Record<string, unknown>} doc - Payload REST document
 * @param {string} [_locale] - Reserved for localized doc fields from Payload API
 * @returns {PromotionCard}
 */
export function mapPromotion(doc, _locale) {
  return {
    key: doc.key,
    title: doc.title,
    content: doc.content,
    image: doc.image,
    category: doc.category,
    url: doc.url,
    publish_at: doc.publishAt || undefined,
    unpublish_at: doc.unpublishAt || undefined,
    buttonLabel: doc.buttonLabel || undefined,
    imageAlt: doc.imageAlt || undefined,
  };
}

/**
 * @param {{ docs?: unknown[] }} payloadResponse
 * @param {string} [locale]
 * @returns {PromotionCard[]}
 */
export function mapPromotionsResponse(payloadResponse, locale) {
  const docs = Array.isArray(payloadResponse?.docs) ? payloadResponse.docs : [];
  return docs.map((doc) => mapPromotion(doc, locale));
}
